


























import { VueConstructor } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  InvestMentHoldingsAction,
  MatchTransactionsAction,
  PeriodUpdatesAction,
  RunReportAction,
} from './icons';
import makeUrlResolver from '@/lib/make-url-resolver';

interface IActionMenuLink {
  label: string;
  path: string;
  pathId?: string;
  icon: VueConstructor;
}

@Component({
  components: {
    InvestMentHoldingsAction,
    MatchTransactionsAction,
    PeriodUpdatesAction,
    RunReportAction,
  },
})
export default class ActionBar extends Vue {
  @Prop({ default: '' }) public baseUrl: string;
  public get links(): IActionMenuLink[] {
    const resolveUrl = makeUrlResolver(this.baseUrl);
    return [
      {
        path: resolveUrl('investment-register/holding-account'),
        icon: InvestMentHoldingsAction,
        label: 'holding accounts',
        pathId: 'ha-path',
      },
      {
        path: resolveUrl('event-manager/match-transactions'),
        icon: MatchTransactionsAction,
        label: 'match transactions',
      },
      {
        path: resolveUrl('periodic-processing/financial-year'),
        icon: PeriodUpdatesAction,
        label: 'period updates',
      },
      {
        path: resolveUrl('report-register/single-report-viewer'),
        icon: RunReportAction,
        label: 'run report',
        pathId: 'srv-path',
      },
    ];
  }
}
